import styled from 'styled-components';

const Wrapper = styled('div')`
	position: relative;
	display: flex;
`;

export {
	Wrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Item/ImageWrapper/styles.ts